import { useRef, useCallback } from 'react';

type AnyFn = (...args: unknown[]) => void;

export function useDebounceCallback<T extends AnyFn>(
  callback: T,
  delay: number
) {
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const debouncedFn = useCallback(
    (...args: Parameters<T>) => {
      if (timer.current) {
        clearTimeout(timer.current);
      }

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return debouncedFn;
}
